import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HandHeart, Mail, ExternalLink } from "lucide-react";

export default function AdminSubmissions() {
  const [tab, setTab] = useState("volunteer");
  const [volunteers, setVolunteers] = useState([]);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    api.get("/admin/volunteer-submissions").then((r) => setVolunteers(r.data.items || [])).catch(() => {});
    api.get("/admin/contact-submissions").then((r) => setContacts(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-submissions">
      <h1 className="text-3xl font-bold text-slate-900">Submissions</h1>
      <p className="text-slate-600 mt-1">Pendaftaran relawan dan pesan kontak yang masuk.</p>

      <div className="mt-6 flex gap-2 border-b border-slate-200">
        <button onClick={() => setTab("volunteer")} className={`px-5 py-3 text-sm font-semibold flex items-center gap-2 border-b-2 transition ${tab === "volunteer" ? "border-[var(--brand-blue)] text-[var(--brand-blue)]" : "border-transparent text-slate-500 hover:text-slate-700"}`} data-testid="sub-tab-volunteer">
          <HandHeart className="h-4 w-4" /> Volunteer ({volunteers.length})
        </button>
        <button onClick={() => setTab("contact")} className={`px-5 py-3 text-sm font-semibold flex items-center gap-2 border-b-2 transition ${tab === "contact" ? "border-[var(--brand-blue)] text-[var(--brand-blue)]" : "border-transparent text-slate-500 hover:text-slate-700"}`} data-testid="sub-tab-contact">
          <Mail className="h-4 w-4" /> Contact ({contacts.length})
        </button>
      </div>

      <div className="mt-6 card-sf overflow-hidden">
        {tab === "volunteer" && (
          <SubmissionTable
            items={volunteers}
            columns={[
              { key: "created_at", label: "Tanggal", render: (r) => new Date(r.created_at).toLocaleString("id-ID") },
              { key: "name", label: "Nama" },
              { key: "email", label: "Email", render: (r) => <a href={`mailto:${r.email}`} className="text-[var(--brand-blue)] hover:underline">{r.email}</a> },
              { key: "phone", label: "Telepon" },
              { key: "city", label: "Kota" },
              { key: "interest", label: "Bidang" },
              { key: "motivation", label: "Motivasi", render: (r) => <span className="text-xs line-clamp-2 max-w-xs block">{r.motivation}</span> },
            ]}
          />
        )}
        {tab === "contact" && (
          <SubmissionTable
            items={contacts}
            columns={[
              { key: "created_at", label: "Tanggal", render: (r) => new Date(r.created_at).toLocaleString("id-ID") },
              { key: "name", label: "Nama" },
              { key: "email", label: "Email", render: (r) => <a href={`mailto:${r.email}`} className="text-[var(--brand-blue)] hover:underline">{r.email}</a> },
              { key: "phone", label: "Telepon" },
              { key: "subject", label: "Subjek" },
              { key: "message", label: "Pesan", render: (r) => <span className="text-xs line-clamp-2 max-w-md block">{r.message}</span> },
            ]}
          />
        )}
      </div>
    </div>
  );
}

function SubmissionTable({ items, columns }) {
  if (items.length === 0) return <div className="p-10 text-center text-slate-500">Belum ada submissions.</div>;
  return (
    <table className="w-full">
      <thead>
        <tr className="bg-slate-50 border-b border-slate-200">
          {columns.map((c) => (
            <th key={c.key} className="text-left px-4 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">{c.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.map((it) => (
          <tr key={it.id} className="border-b border-slate-100 hover:bg-slate-50">
            {columns.map((c) => (
              <td key={c.key} className="px-4 py-3 text-sm text-slate-700">
                {c.render ? c.render(it) : String(it[c.key] ?? "")}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
